import { Component, ViewEncapsulation, OnInit, AfterViewInit, ViewChild, DoCheck, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Dtm, getDtm } from '../../shared/enum/dtm';
import { SYDLEClientID } from '../../shared/constants/one-constants';

// Components
import { DialogLoadingComponent } from '../../shared/components/dialog-loading/dialog-loading.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';

import { PaymentFormComponent } from '../../shared/components/payment-form/payment-form.component';
import { CartComponent } from '../../shared/components/cart/cart.component';
import { SelfAttendanceData } from '../../shared/model/self-attendance-data';

// Models
import { Cart } from '../../shared/model/cart';

// Services
// import { CartService } from '../../shared/services/cart.service';
import { SelfAttendanceService } from '../../shared/services/self-attendance.service';
import { DtmService } from '../../services/dtm.service';

import {
  authReasonCode, braspagReasonCode, adyenReasonCode,
  errorMapping,
  handleIntegrationError
} from '../../shared/constants/errors';
import { UpgradeCheckout } from '../../shared/model/upgrade-checkout';
import { ProductService } from '../../shared/services/product.service';
import { CartService } from '../../shared/services/cart.service';
import { PaymentMethodOption } from 'src/app/shared/model/payment-method-option';
import { CustomerPaymentMethod } from "../../shared/model/customer-payment-method";
import { CreditCardData } from 'src/app/shared/model/credit-card-data';
import { CheckoutService } from 'src/app/shared/services/checkout.service';
import { SessionStorageService } from "../../shared/services/session-storage.service";
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { ECommerceService } from 'src/app/services/e-commerce.service';
import { SuggestionMessage } from 'src/app/shared/model/sugestion-message';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'pme-self-attendance-upgrade',
    templateUrl: './upgrade.component.html',
    styleUrls: ['./upgrade.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelfAttendanceUpgradeComponent implements OnInit, DoCheck, AfterViewInit {

  @ViewChild(CartComponent) cartComponent: CartComponent;
  @ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;

  selfAttendanceData: SelfAttendanceData;

  // URL Parameters
  hashString: string;
  redirectUrl: string;
  returnUrl: string;

  // Provisioning Parameters
  businessId: string;
  userId: string;
  newPlan: string;
  classificationName: string;

  // Hero Information
  heroData: any = {};
  showHero = false;

  // PaymentForm Parameters
  showPaymentForm = false;
  submitting: boolean;

  // Dados do contrato
  currentPaymentMethod: any = {};
  currentPaymentData: any = {};
  termOfUseUrl: string;

  suggestionMessage: SuggestionMessage;
  isACreditCardError: boolean = false;
  adyenCardError: string;

  classificationIdentifier: string;

  lastPaymentMethod: string;

  cart: Cart;
  buttonName: string;
  paymentMethod = 'CREDIT_CARD';
  discountBadge: string;
  maxInstallment: string;
  installmentvalue: string;
  firstCall: boolean;

  paymentOptions: Array<PaymentMethodOption> = [];
  creditCardData: CreditCardData;

  isMobile: boolean = window.innerWidth < 960;

  showCart = false;
  contractErrorData: any = {
    'isPending': false,
    'isSuspended': false,
    'isBankBillet': false,
    'isBankBilletExpired': false,
    'isInvoiceExpired': false,
    'isInvoicePending': false,
    'isCreditCardInvoicePending': false,
  };

  showErrorHero: boolean = false;

  showData: boolean = true;

  creditCardsData: CreditCardData[];
  maxLimitCreditCards: boolean;

  customValue: number = 0;

  constructor(private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public dtmService: DtmService,
    private checkoutService: CheckoutService,
    private productService: ProductService,
    public cartService: CartService,
    private selfAttendanceService: SelfAttendanceService,
    public sessionStorageService: SessionStorageService,
    private eCommerceService: ECommerceService

  ) {
    this.sessionStorageService.clearSessionStorage(["cart"]);
    sessionStorage.setItem('shopWindowRoute', 'upgrade')
    this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);
    this.classificationName = this.sessionStorageService.getClassificationName();

    // this.dtmService.pageLoaded(Dtm.Upgrade, true, getDtm(Dtm.Upgrade, this.classificationIdentifier));
    // this.dtmService.sendPageLoadEvent();
    this.classificationName = this.sessionStorageService.getClassificationName();
    this.route.queryParams.subscribe(params => {
      this.hashString = params.hash;
      this.businessId = params.businessId;
      this.userId = params.userId;
      this.newPlan = params.newPlan;
      this.customValue = params.customValue ? parseFloat(params.customValue) : 0;
      this.sessionStorageService.setAdditionalData({byParameter: {customValue: this.customValue}});
      sessionStorage.setItem('selfAttendance', 'true');

      if (params.validationToken) {
        sessionStorage.setItem('validationToken', params.validationToken);
      }

      if (params.redirectUrl) {
        this.redirectUrl = params.redirectUrl;
        sessionStorage.setItem('redirectUrl', this.redirectUrl);
        this.selfAttendanceService.redirectURL = this.redirectUrl;
      }
      selfAttendanceService.getStoredCreditCards(this.userId, this.businessId, this.hashString).subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];
        this.suggestionMessage = results[2]
      });
    });

    sessionStorage.setItem('isUpgrade', 'true');
  }

  ngOnInit() {
    this.openDialogSpinner();

    this.showHero = true;
    if (this.classificationIdentifier === 'monitore-clientes') {
      this.returnUrl = '/' + this.classificationIdentifier + "/checkout/alteracao-plano?userId=" + this.userId + "&businessId=" + this.businessId + "&redirectUrl=" + this.redirectUrl;
    } else if(this.classificationIdentifier === 'plano-mensal') {
      this.returnUrl = '/plano-mensal/checkout/meu-plano?userId=' + this.userId + '&businessId=' + this.businessId ;
    }else{
      this.returnUrl = this.redirectUrl;
    }     


    this.selfAttendanceService.authenticate(this.classificationIdentifier, this.hashString, this.businessId, this.userId, false).subscribe(
      (authData) => {

        if (authData.userName && authData.userEmail) {
          sessionStorage.setItem('name', authData.userName);
          sessionStorage.setItem('email', authData.userEmail);
        }

        this.businessId = authData.businessId;
        this.userId = authData.userId;

        this.dtmService.userLoaded({
          userId: this.userId,
          businessId: this.businessId,
          clientId: SYDLEClientID
        });

        const tempPaymentMethod = sessionStorage.getItem('paymentMethod');

        if (tempPaymentMethod && tempPaymentMethod !== '') {
          this.paymentMethod = tempPaymentMethod;
        }

        this.cart = this.cartService.getCurrentCart();
        const cartId = this.cart && this.cart._id ? this.cart._id : null;
        const type = 'UPGRADE';

        const validationToken = sessionStorage.getItem('validationToken');
        let additionalData = null;
        if (validationToken) {
          additionalData = { "validationToken": validationToken };
        }
        if (this.customValue) {
          additionalData = { ...additionalData, customValue: this.customValue };
        }

        this.cartService.simulate(cartId, type, this.classificationIdentifier, 'PAYMENT', [], this.userId, this.businessId, null, additionalData, this.newPlan).subscribe(simulateResult => {
          this.cartService.setCarts(simulateResult);
          // this.cartService.setCartByPaymentMethod('CREDIT_CARD');
          this.cartService.setCartByPaymentMethod(simulateResult[0].paymentMethod.identifier);
          this.cart = this.cartService.getCurrentCart();

          // Preenche dados de auto-atendimento
          this.selfAttendanceData = this.cart.selfAttendanceData;

          this.selfAttendanceService.setCurrentSelfAttendanceData(this.selfAttendanceData);

          // Preenche as formas de pgto disponiveis
          if (simulateResult) {
            simulateResult.forEach(cartData => {
              this.paymentOptions.push(cartData.paymentMethod);
            });
          }

          // Preenche a badge do deal do desconto, pro formulario de pagamento
          let bankBilletCart = simulateResult.find(cart => cart.paymentMethod && cart.paymentMethod.identifier === 'BANK_BILLET');
          if (bankBilletCart) {
            let bankBilletDiscount = bankBilletCart.appliedDiscounts.find(disc => disc.identifier === 'BANKBILLETAUTO');
            this.discountBadge = bankBilletDiscount ? bankBilletDiscount.deal : null;
          }
          this.cartComponent.update();

          this.showPaymentForm = true;

          // DTM
          this.dtmService.pageLoaded(Dtm.Upgrade, true, getDtm(Dtm.Upgrade, this.classificationIdentifier));
          this.dtmService.customLoaded([]);
          this.dtmService.sendPageLoadEvent();
          this.bindDtmVariablesEvent();

          if (this.classificationIdentifier === "saude-do-seu-negocio") {
            this.heroData = {
              'title': 'Seja um cliente Premium!',
              'type': 'upgrade-info',
              'contents': [
                `Aproveite os <span class="pme-success-text">10% de desconto</span> e comece já a monitorar seus sócios e suas participações em empresas. Pagando com boleto, seu desconto é ainda maior.`
              ]
            }
          } else {
            this.heroData = {
              'title': this.cart.product.classificationName,
              'type': 'upgrade-info',
              'contents': [
                `Flexibilidade e zero burocracia para ajustar sua assinatura quando e como quiser.`
              ]
            }
          }

          this.closeDialogSpinner();
        }, (err) => {
          this.showCustomError('getPlansAvailableForUpgradeError', err);
        });
      }, (error) => {
        this.showCustomError('authenticationError', error);
      });

    this.showCart = true;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = window.innerWidth < 960;
  }

  ngDoCheck() { }

  ngAfterViewInit(): void {
    this.cartService.cartUpdated.subscribe(_ => this.cart = this.cartService.getCurrentCart());
  }

  onSubmit(paymentData) {
    this.isACreditCardError = false;
    const upgradeCheckout = new UpgradeCheckout({
      'newPlanId': this.selfAttendanceData.upgradeData.product._id,
      'contractCode': this.selfAttendanceData.contract.code,
      'paymentData': paymentData,
      'upgradeCart': this.cart ? this.cart : this.selfAttendanceData.upgradeData.upgradeCart,
      'validationToken': sessionStorage.getItem('validationToken'),
      'discounts': this.cart && this.cart.appliedDiscounts && this.cart.appliedDiscounts.length ? this.cart.appliedDiscounts : null,
      'customValue':this.customValue
    });

    let triggerMessagem = "Finalizar pagamento";

		// Gets the most updated cart
		this.dtmService.customClickEvent(triggerMessagem);

    this.checkoutService.doUpgradeCheckout(upgradeCheckout).subscribe((upgradeResult) => {
      if (upgradeResult && upgradeResult.success) {
        upgradeResult.service = 'upgrade';
        this.selfAttendanceService.setCurrentSelfAttendanceData(upgradeResult);
        this.closeDialogSpinner();

        // // Remove os carrinhos do SS
        // this.cartService.setCart(null);
        // this.cartService.setCarts(null);

        this.router.navigate(['../sucesso'], { relativeTo: this.route });
      }
    }, (error) => {
      this.showCustomError('upgradeError', error);
    });
  }

  onPaymentMethodSelected(paymentMethod: string) {
    this.paymentMethod = paymentMethod;
    this.cartService.setCartByPaymentMethod(this.paymentMethod);

    this.cartComponent.update();

    if (paymentMethod === 'CREDIT_CARD') {
      if (this.classificationIdentifier === "plano-mensal") {
        this.buttonName = 'Confirmar alteração de plano';
      } else {
        this.buttonName = 'Pagar';
      }
    } else if (paymentMethod === 'BANK_BILLET') {
      this.buttonName = 'Gerar boleto';
    } else if (paymentMethod === 'PIX') {
      this.buttonName = 'Gerar chaves e QR Code';
    }
  }

  onPaymentConditionSelected(paymentConditionOption) {
    this.cartService.paymentOptionChanged.next(paymentConditionOption);
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case 'termOfUsedIntegrationError':
        this.paymentForm.addValidationError(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: errorMapping[customErrorKey],
          errorMessage: errorMapping[customErrorKey],
        });
        this.closeDialogSpinner();
        break;
      case 'invalidPaymentOption':
        this.paymentForm.addValidationError(errorMapping[customErrorKey]);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: 'PaymentOptionInválido',
          errorMessage: errorMapping[customErrorKey],
        });
        this.closeDialogSpinner();
        break;
      case 'getPlansAvailableForUpgradeError':
        console.error(integrationErrorMessage);

        if (integrationError && integrationError.error) {
          const error = integrationError.error;
          const SUSPENDED_ERROR_CODES = ['SUSPENDED_EXPIRED_BILLET', 'SUSPENDED_BANK_BILLET', 'SUSPENDED_CREDIT_CARD'];
          const isSuspended = error.generalMessages.some(msg => SUSPENDED_ERROR_CODES.indexOf(msg.code) > -1);
          const isPending = error.generalMessages.some(msg => msg.code === 'PENDING');

          const invoiceIsPending = error.generalMessages.some(msg => msg.code === 'PENDING_INVOICE');
          const invoiceIsExpired = error.generalMessages.some(msg => msg.code === 'EXPIRED_INVOICE');

          const creditCardInvoicePending = error.generalMessages.some(msg => msg.code === 'CREDIT_CARD_PENDING_INVOICE');
          const creditCardInvoiceIsExpired = error.generalMessages.some(msg => msg.code === 'CREDIT_CARD_EXPIRED_INVOICE');

          if (isPending) {
            this.contractErrorData.isPending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'contractPendingError');

          } else if (invoiceIsPending) {
            this.contractErrorData.isInvoicePending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'invocePendingError');

          } else if (creditCardInvoicePending) {
            this.contractErrorData.isCreditCardInvoicePending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'creditCardInvoicePendingError');

          } else if (creditCardInvoiceIsExpired) {
            this.contractErrorData.isCreditCardInvoicePending = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'creditCardInvoiceIsExpiredError');

          } else if (invoiceIsExpired) {
            this.contractErrorData.isInvoiceExpired = true;
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'invoceExpiredError');

          } else if (isSuspended) {
            // Se o erro de integracao pro upgrade foi por causa do status do contrato
            this.contractErrorData.isSuspended = true;

            error.generalMessages.forEach(msg => {
              if (msg.code === 'SUSPENDED_BANK_BILLET') {
                this.contractErrorData.isBankBillet = true;
              } else if (msg.code === 'SUSPENDED_EXPIRED_BILLET') {
                this.contractErrorData.isBankBillet = true;
                this.contractErrorData.isBankBilletExpired = true;
              }
            });
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'contractSuspendedError');
          } else {
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'getPlansAvailableForUpgradeError');
          }
        }
        // integrationErrorMessage = this.showCustomHeroError(integrationError, 'getPlansAvailableForUpgradeError');


        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.closeDialogSpinner();
        break;
      case 'upgradeError':
        integrationErrorMessage = this.handleUpgradeError(integrationError);

        if (['WATCHLIST_INVESTIGATE', 'WATCHLIST_REJECT_CREDITCARD', "WATCHLIST_REJECT_BOLETO", "WATCHLIST_REJECT_PIX", 'MODAL_WATCHLIST_PENDING_PURCHASE'].indexOf(integrationErrorMessage.userMessage) >= 0) {
          this.openErrorDialog(integrationErrorMessage.userMessage);
        } else {
          this.paymentForm.addValidationError(integrationErrorMessage.userMessage);
          console.error(integrationErrorMessage);
          this.closeDialogSpinner();
        }
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'authenticationError':
        integrationErrorMessage = this.showCustomHeroError(integrationError, 'authenticationError');
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.closeDialogSpinner();
        break;
      default:
        break;
    }
    if (this.showPaymentForm) {
      this.paymentForm.submitting = false;
      this.paymentForm.enableFields('all');
    }
  }

  openErrorDialog(dialogData: string, errorDetail?: string, errorMessage?: string) {
    let data = DialogData.fromPreset(dialogData, {
      classificationName: this.classificationName,
      businessId: this.businessId,
      userId: this.userId
    });

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });
  }

  handleUpgradeError(error: any): any {
    let resultError: any = {};

    try {
      this.isACreditCardError = false;
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        let parseObj;
        try {
          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        if (parseObj && parseObj.context !== undefined) {
          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;
        } else {
          resultError.userMessage = resultError.errors[0].text;
          resultError.errorCode = resultError.errors[0].code;
        }

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));
        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if (adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (resultError.userMessage.indexOf('java') >= 0 ||
          resultError.userMessage.indexOf('Java') >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf('elastic') >= 0 ||
          resultError.userMessage.indexOf('Elastic') >= 0) {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        }
        const generalMessageText = error.error.generalMessages[0]?.text;

			const parsedText = JSON.parse(generalMessageText); //trata erro referente ao cartão

			const context = parsedText?.context;
			const message = parsedText?.message;

			if (generalMessageText) {


				if(context === "ADYEN"){

					resultError.userMessage = message;


					this.adyenCardError = message;
					this.isACreditCardError = true;
					if(!this.creditCardsData){
						this.isACreditCardError = false;

					}
				}else{

					this.isACreditCardError = false;
					this.adyenCardError = null;

				}

			  }

      }
    } catch (e) {

    }

    return resultError;
  }

  showCustomHeroError(error, type) {
    const resultError: any = {};
    let isSuspendedError = false;
    let isInvocePendingError = false;
    let isInvoceExpiredError = false;
    let isCreditCardInvoceError = false;
    let isgetPlansAvailableForUpgradeError = false;

    try {
      if (typeof error === 'string') {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === 'ERROR';
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === 'WARNING';
        });

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;
        switch (type) {
          case 'authenticationError':
            if (authReasonCode[resultError.code]) {
              this.heroData.type = 'error';
              this.heroData.title = authReasonCode[resultError.code].title;
              this.heroData.contents = authReasonCode[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
            }

            break;
          case 'paymentChangeDataError':
            // TODO - Implementar para Erros desta pagina
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
            break;
          case 'contractPendingError':
            this.heroData.type = 'error';
            this.heroData.title = 'Seu contrato está pendente!';
            this.heroData.contents = ['Seu contrato está pendente. Aguarde seu contrato ser ativado, e tente novamente!'];
            break;
          case 'contractSuspendedError':
            this.heroData.type = 'error';
            this.heroData.title = 'Seu contrato está suspenso!';
            this.heroData.contents = ['Seu contrato foi suspenso. Normalize a sua situação para realizar um upgrade de plano!'];
            isSuspendedError = true;
            break;
          case 'invocePendingError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura em aberto!';
            this.heroData.contents = ['Seu contrato possui uma fatura em aberto. Normalize a sua situação para realizar um upgrade de plano!'];
            isInvocePendingError = true;
            break;
          case 'creditCardInvoicePendingError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura em aberto!';
            this.heroData.contents = ['Seu contrato possui uma fatura em aberto. Normalize a sua situação para realizar um upgrade de plano!'];
            isCreditCardInvoceError = true;
            break;

          case 'getPlansAvailableForUpgradeError':
          this.heroData.type = 'info';
          this.heroData.title = 'Upgrade máximo alcançado!';
          this.heroData.contents = ['Parece que você já está aproveitando nosso plano máximo. Não há mais planos de upgrade, pois você já desfruta de todos os benefícios disponíveis. Estamos à disposição para qualquer dúvida. Obrigado por escolher nossos serviços!'];
          isgetPlansAvailableForUpgradeError = true;
          break;

          case 'invoceExpiredError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura vencida!';
            this.heroData.contents = ['Seu contrato possui uma fatura vencida que não foi paga. Normalize a sua situação para realizar um upgrade de plano!'];
            isInvoceExpiredError = true;
            break;

          case 'creditCardInvoiceIsExpiredError':
            this.heroData.type = 'error';
            this.heroData.title = 'Fatura vencida!';
            this.heroData.contents = ['Seu contrato possui uma fatura vencida que não foi paga. Normalize a sua situação para realizar um upgrade de plano!'];
            isCreditCardInvoceError = true;
            break;
          default:
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = error.toString();
      this.heroData.type = 'error';
      this.heroData.title = 'Serviço indisponível!';
      this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.'];
    }
    this.heroData.showButton = !isgetPlansAvailableForUpgradeError ? true : null;
    this.heroData.buttonName = isSuspendedError || isInvoceExpiredError || isCreditCardInvoceError ? 'Regularizar pagamento' : isInvocePendingError ? 'Gerar segunda via' : 'Voltar';
    this.heroData.redirectURL = this.getRedirectUrl();

    this.showErrorHero = true;
    return resultError;
  }

  private getRedirectUrl() {

    const host = window.location.origin;
    const planClassification = window.sessionStorage.classificationIdentifier
    const origin = this.contractErrorData.isInvoicePending && !this.contractErrorData.isCreditCardInvoicePending ? '2via' : '';


    const url = host + '/auto-atendimento/' + planClassification + '/alteracao-de-pagamento' + '?businessId=' + this.businessId + '&userId=' + this.userId + '&redirectUrl=' + this.redirectUrl + '&origin=' + origin;

    return url;
  }

  private bindDtmVariablesEvent() {
    // Adobe Analytics Tests
    const fromItem = this.selfAttendanceData.contract.product.identifier;
    const toItem = this.selfAttendanceData.upgradeData.product.identifier;

    sessionStorage.setItem('fromToUpgrade', fromItem + 'TO' + toItem);
    sessionStorage.setItem('nextPlan', toItem);

    let productDtm = {
      classificationName: this.selfAttendanceData.contract.product.classificationName,
      identifier: toItem,
    };

    this.dtmService.customLoaded(['AddToCart', 'Checkout'], 'Sydle-upgrade');
    this.dtmService.productsLoaded([productDtm]);
  }

  handleCartUpdate() {
    const carts = this.cartService.getCarts();
    if (carts) {
      const noPaymentNeededCart = carts.find(cart => cart.allowSaleWithoutPayment);

      if (noPaymentNeededCart && noPaymentNeededCart.allowSaleWithoutPayment
        && noPaymentNeededCart.saleMessageInfo && this.paymentForm) {
        this.cart.allowSaleWithoutPayment = true;
        this.paymentForm.hasPaymentCreditCard = false;
        this.paymentForm.hasPaymentBankBillet = false;
        this.cartComponent.allowAutomaticRecharge = false;
        this.cart.saleMessageInfo = noPaymentNeededCart.saleMessageInfo;
        this.paymentOptions = [];

        const cart = carts.filter(cartData => cartData.paymentMethod.identifier === 'BANK_BILLET')[0];
        this.paymentOptions.push(cart.paymentMethod);
      } else {
        this.cart.saleMessageInfo = null;
        this.cart.allowSaleWithoutPayment = false;
        this.paymentOptions = [];
        carts.forEach((cartData) => {
          this.paymentOptions.push(cartData.paymentMethod);
        });
      }

      this.paymentForm.handleCartUpdated(this.paymentOptions);
    }
  }

  toggleCollapseData() {
    this.showData = !this.showData;
  }

  handleDeleteCreditCard(accountPaymentDataId: string): void {
    this.selfAttendanceService.removeCreditCard(this.userId, this.businessId, accountPaymentDataId)
      .subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];
      });
  }

}
